import { Vehicle } from '@/actions/v2/getClientServices';

export default class VehicleType {
  id: string = '';
  name: string = '';
  localeKey: string = '';
  description: string = '';
  luggageRules: string = '';
  seatCapacity: number = 0;
  luggageCapacity: number = 0;
  safetySeatCapacity: number = 0;
  upgradedFrom: string | null = null;
  price: number = 0;
  canUseCoupon: boolean = true;
  upgradable: any[] = []; //TODO

  constructor(data: Partial<VehicleType> = {}) {
    Object.assign(this, data);
  }

  get isValid(): boolean {
    return Boolean(this.id && this.name && this.seatCapacity > 0);
  }

  clone(): VehicleType {
    return new VehicleType(this);
  }

  static fromClientVehicle(vehicleType: Vehicle): VehicleType {
    return new VehicleType({
      id: vehicleType.id,
      name: vehicleType.name,
      localeKey: vehicleType.localeKey,
      description: vehicleType.description,
      luggageRules: vehicleType.luggageRules,
      seatCapacity: vehicleType.maxPassengerCount,
      luggageCapacity: vehicleType.maxLuggageCount,
      safetySeatCapacity: vehicleType.maxSafetySeatCount,
      upgradedFrom: vehicleType.upgradedFrom,
      price: vehicleType.price,
      canUseCoupon: vehicleType.canUseCoupon,
      upgradable: vehicleType.upgradable,
    });
  }

  toClientVehicle(): Vehicle {
    return {
      id: this.id,
      name: this.name,
      localeKey: this.localeKey,
      description: this.description,
      luggageRules: this.luggageRules,
      maxPassengerCount: this.seatCapacity,
      maxLuggageCount: this.luggageCapacity,
      maxSafetySeatCount: this.safetySeatCapacity,
      upgradedFrom: this.upgradedFrom,
      price: this.price,
      canUseCoupon: this.canUseCoupon,
      upgradable: this.upgradable,
    };
  }
}
